/*
  Quantity +/- for the cart drawer and cart page.

  The theme sends a cart update on every +/- click and locks the cart until it
  comes back, so going from 30 to 100 means waiting on a dozen round trips.
  Here the clicks only change the number on screen; one update is sent once the
  shopper stops clicking for COMMIT_DELAY_MS.

  Step and minimum come from the input (snippets/cart-form.liquid):
    data-qty-step="5" data-qty-min="30"  commercial rolls (same rule as the PDP)
    data-qty-step="1" data-qty-min="0"   everything else (0 removes the line)

  The update itself is the theme's own: we fire `change` on the input, which
  runs its limit check, /cart/change and redraw (and cart-loading.js's busy
  state).
*/
(function () {
  var COMMIT_DELAY_MS = 400;
  var BUTTONS = '[data-ajax-qty-decrease], [data-ajax-qty-increase]';
  var timers = new WeakMap();

  function rules(input) {
    return {
      step: parseInt(input.dataset.qtyStep, 10) || 1,
      min: parseInt(input.dataset.qtyMin, 10) || 0
    };
  }

  // Clamp to the minimum and round up to the next step (47 -> 50 for rolls).
  // 0 is kept as-is: it means "remove".
  function normalize(input, value) {
    var r = rules(input);
    if (isNaN(value) || value < 0) value = r.min || 1;
    if (value === 0) return 0;
    if (value < r.min) value = r.min;
    var offset = value - r.min;
    if (offset % r.step) value = r.min + Math.ceil(offset / r.step) * r.step;
    return value;
  }

  function syncDecrease(input) {
    var down = input.parentNode.querySelector('[data-ajax-qty-decrease]');
    if (!down) return;
    var r = rules(input);
    down.disabled = r.min > 0 && parseInt(input.value, 10) <= r.min;
  }

  function scheduleCommit(input) {
    clearTimeout(timers.get(input));
    timers.set(input, setTimeout(function () {
      timers.delete(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, COMMIT_DELAY_MS));
  }

  // Capture phase on document runs before the theme's listeners on the buttons;
  // stopping propagation here keeps them (and their instant update) from running.
  document.addEventListener('click', function (e) {
    var button = e.target.closest(BUTTONS);
    if (!button) return;
    var input = button.parentNode.querySelector('input[data-item-qty]');
    if (!input) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var r = rules(input);
    var current = parseInt(input.value, 10) || 0;
    var next;
    if (button.hasAttribute('data-ajax-qty-increase')) {
      next = current < r.min ? r.min : current + r.step;
    } else {
      next = current - r.step;
      if (next < r.min) next = r.min;
      if (next < 0) next = 0;
    }
    if (next === current) return;

    input.value = next;
    syncDecrease(input);
    scheduleCommit(input);
  }, true);

  // Typed quantities: snap to the rules before the theme reads the value.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('input[data-item-qty][data-qty-step]')) return;
    clearTimeout(timers.get(input));
    timers.delete(input);
    input.value = normalize(input, parseInt(input.value, 10));
    syncDecrease(input);
  }, true);

  // Lines that are already below the minimum (e.g. added before the rule
  // existed) are bumped up once per page view.
  var bumped = {};
  function enforceMinimums() {
    document.querySelectorAll('input[data-item-qty][data-qty-min]').forEach(function (input) {
      var r = rules(input);
      var value = parseInt(input.value, 10) || 0;
      var key = input.dataset.itemKey;
      if (r.min > 0 && value > 0 && value < r.min && !bumped[key]) {
        bumped[key] = true;
        input.value = r.min;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  enforceMinimums();
  document.querySelectorAll('.js-ajax-cart-content').forEach(function (el) {
    new MutationObserver(enforceMinimums).observe(el, { childList: true });
  });
})();
